const setCookie = function (cname, cvalue, exdays) {
    const d = new Date();
    d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
    let expires = "expires=" + d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

const getCookie = function (cname) {
    let name = cname + "=";
    let ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
}

document.addEventListener("DOMContentLoaded", () => {

    const newsWraper = document.querySelector('.news__wrapper'),
        headerContent = document.querySelector('.header__content-title'),
        closeNews = document.querySelector('.news__btn-close');

    if (newsWraper !== null) {

        closeNews.addEventListener('click', () => {
            newsWraper.classList.add('d-none');
            setCookie('top_news', 'yes', 2);
        });

        let topNews = getCookie('top_news');
        if (topNews) {
            newsWraper.classList.add('d-none');
        } else {
            newsWraper.classList.remove('d-none');
        }
    }
});
